var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3828 9.27344L18.9766 0.867188C18.7422 0.632813 18.4258 0.5 18.0938 0.5H1.5C0.808594 0.5 0.25 1.05859 0.25 1.75V34.25C0.25 34.9414 0.808594 35.5 1.5 35.5H26.5C27.1914 35.5 27.75 34.9414 27.75 34.25V10.1602C27.75 9.82812 27.6172 9.50781 27.3828 9.27344ZM24.8672 10.7344H17.5156V3.38281L24.8672 10.7344ZM24.9375 32.6875H3.0625V3.3125H14.8594V11.75C14.8594 12.1851 15.0322 12.6024 15.3399 12.9101C15.6476 13.2178 16.0649 13.3906 16.5 13.3906H24.9375V32.6875ZM13.6875 22.1406H6.5C6.32812 22.1406 6.1875 22.2812 6.1875 22.4531V24.3281C6.1875 24.5 6.32812 24.6406 6.5 24.6406H13.6875C13.8594 24.6406 14 24.5 14 24.3281V22.4531C14 22.2812 13.8594 22.1406 13.6875 22.1406ZM6.1875 17.1406V19.0156C6.1875 19.1875 6.32812 19.3281 6.5 19.3281H21.5C21.6719 19.3281 21.8125 19.1875 21.8125 19.0156V17.1406C21.8125 16.9688 21.6719 16.8281 21.5 16.8281H6.5C6.32812 16.8281 6.1875 16.9688 6.1875 17.1406Z",
    fill: "#F3C262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.fd30b72284de661612a851d7d6f5fa4c.svg";
export { ForwardRef as ReactComponent };